import clientService from '@/api/client'
import { CLIENT } from '../types'
import router from '@/router'
import EventBus from 'login/EventBus'
import storage from '@/utils/storage'

export default {
  namespaced: true,
  state: {
    clients: [],
    clientIdDesk4Me: '',
    clientIdFreeroom: '',
    originalDesk4MeId: null,
    originalFreeroomId: null,
    clientDesksQuota: null,
    clientDomains: []
  },
  getters: {
    clientIdDesk4Me (state) {
      return state.clientIdDesk4Me
    },
    clientIdFreeroom (state) {
      return state.clientIdFreeroom
    },
    originalDesk4MeId (state) {
      return state.originalDesk4MeId
    },
    originalFreeroomId (state) {
      return state.originalFreeroomId
    },
    clientId(state){
      return state.clientIdFreeroom ? state.clientIdFreeroom : state.clientIdDesk4Me
    },
    clientDesksQuota (state) {
      return state.clientDesksQuota
    },
    clients (state) {
      return state.clients
    }
  },
  mutations: {
    [CLIENT.CLIENT_SET] (state, clients) {
      state.clients = clients
    },
    [CLIENT.SET_CLIENT_CONFIG] (state, item) {
      if (state.originalDesk4MeId) {
        state.originalDesk4MeId = state.clientIdDesk4Me
        storage.saveToLocalStorage('originalDesk4MeId', state.clientIdDesk4Me)
      }

      state.clientIdDesk4Me = item.workspaceId
      storage.saveToLocalStorage('clientIdDesk4Me', item.workspaceId)
      
      if (state.originalFreeroomId) {
        state.originalFreeroomId = state.clientIdFreeroom
        storage.saveToLocalStorage('originalFreeroomId', state.clientIdFreeroom)
      }

      state.clientIdFreeroom = item.meetingSpaceId
      storage.saveToLocalStorage('clientIdFreeroom', item.meetingSpaceId)
      
      state.clientDesksQuota = item.desksQuota
    },
    [CLIENT.RESTORE_CLIENT_CONFIG] (state) {
      state.clientIdDesk4Me = state.originalDesk4MeId
      state.clientIdFreeroom = state.originalFreeroomId
      state.originalDesk4MeId = null
      state.originalFreeroomId = null
      state.clientDesksQuota = null
    },
    [CLIENT.SET_CLIENT_ID] (state, ids) {
      state.clientIdDesk4Me = ids.desk4me
      state.clientIdFreeroom = ids.freeroom
    },
    [CLIENT.SET_CLIENT_ADMIN] (state, obj){
      state.clientIdDesk4Me = obj.clientIdDesk4Me
      state.clientIdFreeroom = obj.clientIdFreeroom
      state.originalDesk4MeId = obj.originalDesk4MeId
      state.originalFreeroomId = obj.originalFreeroomId
    },
    [CLIENT.SET_CLIENT_DOMAINS] (state, domains) {
      state.clientDomains = domains
    }
  },
  actions: {
    getClientsList: function ({ commit, dispatch }) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        clientService.getClients().then((response) => {
          dispatch('Global/hideLoading', null, {root: true})
          commit(CLIENT.CLIENT_SET, response.data)
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    getClientDomains: function ({dispatch}){
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        clientService.getClientDomains().then((response) => {
          dispatch('Global/hideLoading', null, {root: true})
          resolve(response.data.domains)
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    addClient: function ({dispatch}, client) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        clientService.addClient(client).then(() => {
          dispatch('Global/hideLoading', null, {root: true})
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    editClient: function ({dispatch}, client) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        clientService.editClient(client).then(() => {
          dispatch('Global/hideLoading', null, {root: true})
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    activateClient: function (_, clientId) {
      return new Promise((resolve, reject) => {
        clientService.activateClient(clientId).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    deactivateClient: function (_, clientId) {
      return new Promise((resolve, reject) => {
        clientService.deactivateClient(clientId).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    scheduleRemovalClient: function ({dispatch}, obj) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
          clientService.scheduleRemovalClient(obj.clientId, { removeAt : obj.removeAt } ).then(() => {
          resolve()
          dispatch('Global/showMessage', 'clientRemovalScheduled', {root: true})
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    cancelRemovalClient: function ({dispatch}, clientId) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        clientService.cancelRemovalClient(clientId).then(() => {
          resolve()
          dispatch('Global/showMessage', 'clientRemovalCanceled', {root: true})
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    setClient ({commit}, item) {
      EventBus.publish("setClient", item)
      commit(CLIENT.SET_CLIENT_CONFIG, item)
    },
    restoreClient ({commit}) {
      commit(CLIENT.RESTORE_CLIENT_CONFIG)
      router.push('/')
    },
    setClientId ({commit}, ids) {
      commit(CLIENT.SET_CLIENT_ID, ids)
    },
    setClientDomains ({commit}, domains) {
      commit(CLIENT.SET_CLIENT_DOMAINS, domains)
    },
    setClientAdmin ({commit}, obj) {
      commit(CLIENT.SET_CLIENT_ADMIN, obj)
    }
  }
}
